module.exports = __webpack_public_path__ + "media/rubber_3.405edd98.webm";